<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  height: 100vh;
}

body {
  background-color: #f1f1f1;
  font-family: freight-sans-pro, sans-serif;
}

@media screen and (max-width: 768px) {
  /* Stack columns on small screens */
  div {
    flex-direction: column;
  }
}

.content {
  margin: 20px; /* Default for small screens */
}

@media (min-width: 768px) {
  .content {
    margin: 20px 60px; /* Top & Bottom: 20px, Left & Right: 60px */
  }
}

button {
  background: #001F5A;
  border: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 22px 24px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
}

button:hover {
  opacity: 0.8;
}

.container {
  text-align: center;
  max-width: 600px;
  padding: 30px;
  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: auto auto 20px;
}

.title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #001F5A;
}

.booking-ref {
  font-size: 18px;
}

.confirmation-message {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
}

.details {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
}

.callout {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 15px;
}

</style>